<template>
  <div class="vendedor-cliente-abm">
    <b-card no-header>
      <form>
        <b-form-group
          label="Cliente"
          label-for="cliente"
          :label-cols="labelCols"
          horizontal>
          <b-input-group>
            <b-input-group-append
                v-if="!clienteReadOnly" 
                class="filter-search-icons" 
                @click="seleccionarCliente">
              <b-input-group-text>
                <i :class="{ 'fa fa-search': !cliente,
                              'fa fa-remove': cliente  }"></i>
              </b-input-group-text>
            </b-input-group-append>
            <b-form-input 
              id="cliente"
              :value="clienteNombre"
              readonly
              :state="clienteValido"
              type="text"/>
            <b-form-invalid-feedback id="clienteFeedback">
              {{ clienteInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-input-group>
        </b-form-group>

        <app-cliente-contacto
          v-if="!clienteContactoReadOnly" 
          label="Contacto"
          :nombre="clienteContactoNombre"
          :labelCols="labelCols"
          :lista="clientesContactosList"
          :nullDisabled="Boolean(false)"
          @updated="clienteContactoActualizado">
        </app-cliente-contacto>  

        <b-form-group
          v-if="clienteContactoReadOnly" 
          label="Contacto"
          label-for="clienteContacto"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="clienteContacto"
            :value="clienteContactoNombre"
            readonly
            type="text"/>
        </b-form-group>

        <b-form-group
          class="tipo-comision"
          label="Tipo de Comisión"
          label-for="tipoComision"
          :label-cols="labelCols"
          horizontal>
          <b-form-radio 
            v-model="tipoComisionPorcentaje" 
            name="opcionTipoComision" 
            :value="Boolean(true)"
            stacked>Porcentaje</b-form-radio>
          <b-form-radio 
            v-model="tipoComisionImporte" 
            name="opcionTipoComision" 
            :value="Boolean(true)"
            stacked>Importe</b-form-radio>
          <b-form-radio 
            v-model="tipoComisionPorcentajeImporte" 
            name="opcionTipoComision" 
            :value="Boolean(true)"
            stacked>Porcentaje + Importe</b-form-radio>
        </b-form-group>

        <b-form-group
          class="tipo-porcentaje"
          label="Tipo de Porcentaje"
          label-for="tipoPorcentaje"
          :label-cols="labelCols"
          horizontal>
          <b-form-radio 
            v-model="tipoPorcentajeFijo" 
            name="opcionTipoPorcentaje" 
            :value="Boolean(true)"
            :disabled="tipoComisionImporte"
            stacked>Porcentaje fijo</b-form-radio>
  
          <b-form-group 
            description="Pje de comisión">
            <b-form-input 
              id="pjeComision"
              v-model.trim="$v.pjeComision.$model" 
              :state="pjeComisionValido"
              type="number"
              :readonly="tipoComisionImporte || tipoPjeComision == 2">
            </b-form-input>
            <b-form-invalid-feedback id="pjeComisionFeedback">
              {{ pjeComisionInvalidoMsj }}
            </b-form-invalid-feedback>
          </b-form-group>
    
          <b-form-radio 
            v-model="tipoPorcentajeFee" 
            name="opcionTipoPorcentaje" 
            :value="Boolean(true)"
            :disabled="tipoComisionImporte"
            stacked>Porcentaje del Fee</b-form-radio>
          
          <b-form-group 
            description="Pje del Fee como Comisión">
            <b-form-input 
              id="pjeFeeComision"
              v-model.trim="$v.pjeFeeComision.$model" 
              :state="pjeFeeComisionValido"
              type="number"
              :readonly="tipoComisionImporte || tipoPjeComision == 1">
            </b-form-input>
            <b-form-invalid-feedback id="pjeFeeComisionFeedback">
              {{ pjeFeeComisionInvalidoMsj }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </b-form-group>
      
        <b-form-group
          label="Importe"
          label-for="importeComision"
          :label-cols="labelCols"
          horizontal>
          <b-form-input 
            id="importeComision"
            v-model.trim="$v.importeComision.$model" 
            :state="importeComisionValido"
            type="number"
            :readonly="tipoComisionPorcentaje">
          </b-form-input>
          <b-form-invalid-feedback id="importeComisionFeedback">
            {{ importeComisionInvalidoMsj }}
          </b-form-invalid-feedback>          
        </b-form-group>
      </form>

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="actualizarCliente">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button" 
          @click.prevent="cancelar">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchClienteModal" 
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="clientes-search-modal">
      <app-search-cliente
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>
  </div>
</template>

<script>
import SearchCliente from '../clientes/SearchList.vue';
import ClienteContacto from '../shared/abmSelect.vue';
import { required, decimal } from 'vuelidate/lib/validators';

export default {
  name: 'VendedorCliente',
  components: {
    appSearchCliente: SearchCliente,
    appClienteContacto: ClienteContacto
  },
  props: {
    vendedorCliente: {
      type: Object,
      required: false
    }
  },
  data: () => {
    return {
      cliente: null,
      clienteReadOnly: false,
      clienteContacto: null,
      clienteContactoReadOnly: false,
      tipoComision: 1,
      tipoPjeComision: 1,
      pjeComision: 0,
      pjeFeeComision: 0,
      importeComision: 0,

      clienteValido: null,
      clienteInvalidoMsj: '',
      pjeComisionValido: null,
      pjeComisionInvalidoMsj: '',
      pjeFeeComisionValido: null,
      pjeFeeComisionInvalidoMsj: '',
      importeComisionValido: null,
      importeComisionInvalidoMsj: '',

      clientesContactos: [],
      clientesContactosList: [],
      loadingContactos: false,

      labelCols: 3
    }
  },
  computed: {
    clienteId() {
      if (this.cliente) {
        if (this.cliente.id) {
          return this.cliente.id;
        }
      }
      return 0;
    },
    clienteNombre() {
      if (this.cliente) {
        if (this.cliente.nombre) {
          return this.cliente.nombre;
        }
      }
      return null;
    },
    clienteContactoId() {
      if (this.clienteContacto) {
        if (this.clienteContacto.id) {
          return this.clienteContacto.id;
        }
      }
      return 0;
    },
    clienteContactoNombre() {
      if (this.clienteContacto) {
        if (this.clienteContacto.nombre) {
          return this.clienteContacto.nombre;
        }
      }
      return null;
    },
    tipoComisionPorcentaje: {
      get() {
        return this.tipoComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 1;
        }
      }
    },
    tipoComisionImporte: {
      get() {
        return this.tipoComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 2;
        }
      }
    },
    tipoComisionPorcentajeImporte: {
      get() {
        return this.tipoComision == 3;
      },
      set(newVal) {
        if (newVal) {
          this.tipoComision = 3;
        }
      }
    },
    tipoPorcentajeFijo: {
      get() {
        return this.tipoPjeComision == 1;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 1;
        }
      }
    },
    tipoPorcentajeFee: {
      get() {
        return this.tipoPjeComision == 2;
      },
      set(newVal) {
        if (newVal) {
          this.tipoPjeComision = 2;
        }
      }
    }
  },  

  created() {
    if (this.vendedorCliente) {
      this.cliente = this.vendedorCliente.cliente;
      this.clienteReadOnly = Boolean(true);
      this.clienteContacto = this.vendedorCliente.clienteContacto;
      this.clienteContactoReadOnly = Boolean(true);
      this.tipoComision = this.vendedorCliente.tipoComision;
      this.tipoPjeComision = this.vendedorCliente.tipoPjeComision;
      this.pjeComision = this.vendedorCliente.pjeComision;
      this.pjeFeeComision = this.vendedorCliente.pjeFeeComision;
      this.importeComision = this.vendedorCliente.importeComision;
    }
  },  
  methods: {
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(cliente) {
      this.$refs.searchClienteModal.hide();
      this.cliente = cliente;
      this.getContactos();

      this.clienteValido = null;
      this.clienteInvalidoMsj = '';
    },
    clienteContactoActualizado(clienteContactoNombre) {
      let clienteContacto = null;
      if (clienteContactoNombre) {
        clienteContacto = this.getSelected(this.clientesContactos, clienteContactoNombre);
      }

      this.clienteContacto = clienteContacto;
    },
    getContactos() {
      this.clientesContactos = [];
      this.clientesContactosList = [];

      if (this.clienteId)
      {
        if (this.clienteId != 0) {
          this.loadingContactos = true;
          this.procesando = Boolean(true);
          this.$store.dispatch('clientescontactos/getClientesContactosList', this.clienteId)
            .then(() => {
              this.clientesContactos = this.$store.getters['clientescontactos/contactosList'];
              this.clientesContactosList = this.$store.getters['clientescontactos/contactosSelectList'];
              this.loadingContactos = false;
            })
            .catch(() => this.showErrorMsj('Se produjo un error al recuperar la información de contactos del cliente.'));
        }
      }
    },
    actualizarCliente() {
      let actualizar = true;

      this.$v.$touch();

      let errorCliente = true;
      if (this.cliente) {
        if (this.cliente.id) {
          if (this.cliente.id != 0) {
            errorCliente = false;
          }
        }
      }
      if (errorCliente) {
        this.clienteValido = false;
        this.clienteInvalidoMsj = "Debe seleccionar el cliente correspondiente.";
        actualizar = false;
      }

      if (this.$v.pjeComision.$error) {
        this.pjeComisionValido = false;
        if (!this.$v.pjeComision.decimal) {
          this.pjeComisionInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico.';
        }      
        actualizar = false;
      } else {
        this.pjeComisionValido = null;
        this.pjeComisionInvalidoMsj = '';
      }
      // console.log(actualizar);

      if (this.$v.pjeFeeComision.$error) {
        this.pjeFeeComisionValido = false;
        if (!this.$v.pjeFeeComision.decimal) {
          this.pjeFeeComisionInvalidoMsj = 'El porcentaje de comisión debe ser un valor numérico.';
        }      
        actualizar = false;
      } else {
        this.pjeFeeComisionValido = null;
        this.pjeFeeComisionInvalidoMsj = '';
      }

      if (this.$v.importeComision.$error) {
        this.importeComisionValido = false;
        if (!this.$v.importeComision.decimal) {
          this.importeComisionInvalidoMsj = 'El importe de comisión debe ser un valor numérico.';
        }      
        actualizar = false;
      } else {
        this.importeComisionValido = null;
        this.importeComisionInvalidoMsj = '';
      }

      if (actualizar) {
        let pjeComision = this.tipoComisionPorcentaje || this.tipoComisionPorcentajeImporte? (this.tipoPorcentajeFijo? this.pjeComision : 0) : 0;
        let pjeFeeComision = this.tipoComisionPorcentaje || this.tipoComisionPorcentajeImporte? (this.tipoPorcentajeFee? this.pjeFeeComision : 0) : 0;
        let importeComision = this.tipoComisionImporte  || this.tipoComisionPorcentajeImporte? this.importeComision : 0;

        let params = {
          cliente: this.cliente,
          clienteContacto: this.clienteContacto,
          tipoComision: this.tipoComision,
          tipoPjeComision: this.tipoPjeComision,
          pjeComision,
          pjeFeeComision,
          importeComision
        }
        this.$emit('actualizarCliente', params)
      }
    },
    cancelar() {
      this.$emit('cancelar')
    }
  },
  validations: {
    pjeComision: {
      decimal
    },
    pjeFeeComision: {
      decimal
    },
    importeComision: {
      decimal
    }
  },  
  watch: {
  }    
}
</script>

<style>
  .vendedor-cliente-abm .custom-radio {
    margin-bottom: 10px;
  }
  .vendedor-cliente-abm .form-group.tipo-comision .col,
  .vendedor-cliente-abm .form-group.tipo-porcentaje .col {
    padding-top: 20px;
  }
  .vendedor-cliente-abm input[type=number] {
    appearance: textfield;
    -moz-appearance:textfield;
  }
  .vendedor-cliente-abm input[type=number]::-webkit-inner-spin-button, 
  .vendedor-cliente-abm input[type=number]::-webkit-outer-spin-button { 
    -webkit-appearance: none; 
  }  
</style>
